import React from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { AdvancedSearchItems } from "../item-cards";
import { useEffect } from "react";
import useIsAdvancedSearchMobile from "../hooks/useIsAdvancedSearchMobile";

/**
 * Componente que muestra las opciones de géneros
 *
 * @param {object} props
 * @param {object} props.textos - Textos de interfaz.
 * @param {object} props.data - Datos de búsqueda avanzada.
 * @param {boolean} props.isMobile - Indica si se muestra en versión mobile.
 * @param {Function} props.onClose - Función para cerrar la búsqueda avanzada.
 * @returns {JSX.Element}
 */
export const AdvancedSearchGenres = ({
    textos,
    data,
    isMobile = false,
    onClose,
}) => {
    const history = useHistory();

    const genres = data?.mostSearched?.filter((item) => item?.type === "genero") || [];

    const isAdvancedSearchMobile = useIsAdvancedSearchMobile();

    const getGenreName = (genre) => {
        return (
            _.get(
                textos,
                genre?.name?.translationPath
            ) ||
            genre?.name?.defaultValue
        );
    };

    const handleGenreClick = (genre) => {
        history.push({
            pathname: "/busqueda",
            search: `?${genre?.type}=${genre?.id}`,
            state: {
                forceSearchByParams: true,
            },
        });

       onClose && onClose();
    };

    return (
        <section className="advanced-search-genres pb-5 pt-4">
            <h2 className="section-title">
                {textos?.content?.titulo1 || "Géneros"}
            </h2>

            <div className="d-sm-flex flex-wrap mt-2">
                {genres.map((genre, index) => (
                    <div
                        key={`${genre?.id}-${index}`}
                        className={`px-2 ${isAdvancedSearchMobile ? "col-md-6 col-lg-3 ": "col-md-6"}`}
                    >
                        <AdvancedSearchItems.ItemCard
                            imgPath={genre?.imgPath}
                            name={getGenreName(genre)}
                            onClick={() =>
                                handleGenreClick(genre)
                            }
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};